import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { DebounceConfig } from 'config/debounce.config';
import { DirectivesModule } from 'app/directives/directives.module';

import { MatSelectModule } from '@angular/material/select';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { routes } from 'app/app-routing.module';
import { LandingPageComponent } from './landing/landing-page.component';
import { ProductDetailComponent } from './product/product-detail.component';
import { BillingPageComponent } from './billing/billing-page.component';
import { OrderReviewComponent } from './review/order-review.component';
import { OrderConfirmationComponent } from './confirmation/order-confirmation.component';
import { ProductService } from 'app/services/product.service';
import { CustomerService } from 'app/services/customer.service';
import { OrderService } from 'app/services/order.service';
import { RenewSubscriptionsComponent } from './renew/renew-page.component';
import { AbandonRedirectComponent } from './abandon-redirect/abandon-redirect.component';

@NgModule({
  declarations: [
    LandingPageComponent,
    ProductDetailComponent,
    BillingPageComponent,
    OrderReviewComponent,
    RenewSubscriptionsComponent,
    OrderConfirmationComponent,
    AbandonRedirectComponent
  ],
  imports: [ 
    CommonModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    FormsModule,
    DirectivesModule,
    MatButtonModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatExpansionModule,
    MatFormFieldModule,
	  MatInputModule,
    MatDialogModule,
    MatCheckboxModule,
    MatIconModule,
    MatTableModule
  ],
  providers: [
    DebounceConfig,
    ProductService,
    CustomerService,
    OrderService
  ]
})
export class OCMUserModule {}
